import { CONTRACT_BLOCK_ACTION_MODE } from "interfaces";
import { observer } from "mobx-react-lite";

import { useStores } from "stores";
import { CustomButton } from "ui";

import { ContractBlockActionModal } from "./ContractBlockActionModal";

export const UnblockContractBtn = observer(() => {
  const { actionModals } = useStores();

  const openUnblockContractModal = () => {
    actionModals.open(() => <ContractBlockActionModal mode={CONTRACT_BLOCK_ACTION_MODE.UNBLOCK} />, {
      width: "600px",
      noValidation: true,
      isOverlayClose: false,
      title: "Разблокировать договор",
      onApply: () => Promise.resolve(),
    });
  };

  return (
    <CustomButton type="default" tooltip="Разблокировать договор" onClick={openUnblockContractModal}>
      Разблокировать
    </CustomButton>
  );
});
